(function () {
    'use strict';

    angular
        .module('app')
        .component('museoListAdmin', {
            templateUrl: 'app/components/aspg/museos/admin/museo/museo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Museo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Museo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Museo) {
                            return Museo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'museos.museo.admin.delete.title',
                                body: 'museos.museo.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
